var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"f-32"},[_c('div',{staticClass:"alive_content"},[_c('img',{attrs:{"src":require("@/v2/auto/assets/image/32/slogan.svg")}})])])
}]

export { render, staticRenderFns }